module.exports = __webpack_public_path__ + "img/background0.ed9fccc7.png";